import API from "@utils/request";
let Language = localStorage.getItem('currentLanguage');  //获取本地语言
let prout = 'protal';
if (!Language || Language == 'zh') {
    prout = 'protal';
} else {
    prout = 'protal_' + Language;
}

export async function getAboutData(params) {
    try {
        return await API.post("/api/" + prout + "/api/about/aboutInfo", params);
    } catch (error) {
        return error;
    }
}